"use client";
import { useContext } from "react";
import { BrowserSessionContext } from "./browser-session-context";
import type { BrowserSessionContextValue } from "./browser-session-state";

export function useBrowserSession(): BrowserSessionContextValue {
  const session = useContext(BrowserSessionContext);

  if (!session)
    throw new Error("Browser session requires BrowserSessionProvider");

  return session;
}
